<h1 i18n="@@upp.markets.create.title">Create Market</h1>

<div class="container-fluid">
  <ama-loading-alert [sendingStatus]="sendingStatus" message="Loading..." i18n-message="@@upp.global.messages.loading">
  </ama-loading-alert>
</div>

<ama-upp-notification
  [mainMessages]="mainMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
  (openDisplayEvent)="showMarketInDisplay()"
>
</ama-upp-notification>

<ama-ng-upp-markets-details
  [marketDetailsForm]="marketForm!"
  [marketDetails]="marketDetails"
  [readonly]="readonly"
  [parent]="uppComponent"
>
</ama-ng-upp-markets-details>

<div class="d-flex justify-content-end">
  @if (!sendingStatus) {
  <button
    i18n="@@upp.global.button.save"
    type="submit"
    class="btn btn-primary mb-2 mb-md-0 me-2"
    [disabled]="!saveButtonEnabled()"
    (click)="saveData()"
  >
    Save
  </button>
  } @if (sendingStatus) {
  <button i18n="@@upp.global.button.save" type="button" disabled class="btn btn-primary mb-2 mb-md-0 me-2">
    Save
  </button>
  }
</div>
